module.exports = __webpack_public_path__ + "static/img/logo_poweredby.bb9a421.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients/logo_poweredby.svg
// module id = E1Nf
// module chunks = 1